import { types } from 'mobx-state-tree'

export const DialogStore = types
  .model('DialogStore', {
    isOpened: false,
  })
  .actions(self => ({
    open() {
      self.isOpened = true
    },
    close() {
      self.isOpened = false
    },
  }))

export default DialogStore
